/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useMutation, useSuspenseQuery } from '@apollo/client';
import classNames from 'classnames/bind';
import { Suspense, useState } from 'react';
import { FancyBoolean, PageLoader, GenericErrorBoundary } from '../../components';
import {
  GET_CURRENT_USER_PRIVACY_PREFS,
  UPDATE_PRIVACY_PREFERENCES,
} from './ACCOUNT_FORMS_MUTATIONS_AND_QUERIES';
import DeactivateProfile from './DeactivateProfile';
import styles from './styles.module.scss';
import { useAlertMessage } from '../../hooks';

const cx = classNames.bind(styles);

interface Props {
  cancel: () => void;
}

const PrivacySettings = ({ cancel }: Props) => {
  const [showDeactivate, setShowDeactivate] = useState(false);

  const {
    data: { currentUser },
    refetch,
  } = useSuspenseQuery(GET_CURRENT_USER_PRIVACY_PREFS);

  const currentShareEmail = !!currentUser?.privacy_preferences?.share_email;
  const currentSharePhone = !!currentUser?.privacy_preferences?.share_phone;

  const [updatePrivacyMutation] = useMutation(UPDATE_PRIVACY_PREFERENCES);

  const { showSuccess, showError } = useAlertMessage();

  const updateUser = async ({
    shareEmail,
    sharePhone,
  }: {
    shareEmail?: boolean;
    sharePhone?: boolean;
  }) => {
    if (!currentUser) {
      showError('You are not logged in.');
      return;
    }

    try {
      await updatePrivacyMutation({
        variables: {
          userId: currentUser._id,
          share_email: typeof shareEmail === 'boolean' ? shareEmail : currentShareEmail,
          share_phone: typeof sharePhone === 'boolean' ? sharePhone : undefined,
        },
      });
      showSuccess('Successfully updated privacy preferences.');
      refetch();
    } catch (error) {
      showError(error);
    }
  };

  return (
    <div className={cx('account-form', 'privacy-form')}>
      {showDeactivate ? (
        <DeactivateProfile />
      ) : (
        <>
          <div className={cx('fields-wrap')}>
            <p>Share the following contact information with my teammates:</p>
            <br />
            <div className="text-center">
              <FancyBoolean
                toggle
                onChange={() => updateUser({ shareEmail: !currentShareEmail })}
                value={currentShareEmail}
                label="Email"
              />
              <FancyBoolean
                toggle
                onChange={() => updateUser({ sharePhone: !currentSharePhone })}
                value={currentSharePhone}
                label="Phone"
              />
            </div>
          </div>
          <div className={cx('fields-wrap', 'mt-4', 'font-italic', 'text-center')}>
            <a role="link" tabIndex={0} onClick={() => setShowDeactivate(true)}>
              <small className="text-volo-danger">Delete Account</small>
            </a>
          </div>
          <a className={cx('cancel-button')} onClick={cancel} role="link" tabIndex={0}>
            Back
          </a>
        </>
      )}
    </div>
  );
};

export default (props: Props) => (
  <GenericErrorBoundary>
    <Suspense fallback={<PageLoader />}>
      <PrivacySettings {...props} />
    </Suspense>
  </GenericErrorBoundary>
);
